/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericDocumentDto } from './GenericDocumentDto';
import {
    GenericDocumentDtoFromJSON,
    GenericDocumentDtoFromJSONTyped,
    GenericDocumentDtoToJSON,
    GenericDocumentDtoToJSONTyped,
} from './GenericDocumentDto';

/**
 * 
 * @export
 * @interface GetContractDocumentsResponseDto
 */
export interface GetContractDocumentsResponseDto {
    /**
     * 
     * @type {Array<GenericDocumentDto>}
     * @memberof GetContractDocumentsResponseDto
     */
    documents: Array<GenericDocumentDto>;
}

/**
 * Check if a given object implements the GetContractDocumentsResponseDto interface.
 */
export function instanceOfGetContractDocumentsResponseDto(value: object): value is GetContractDocumentsResponseDto {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function GetContractDocumentsResponseDtoFromJSON(json: any): GetContractDocumentsResponseDto {
    return GetContractDocumentsResponseDtoFromJSONTyped(json, false);
}

export function GetContractDocumentsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractDocumentsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(GenericDocumentDtoFromJSON)),
    };
}

export function GetContractDocumentsResponseDtoToJSON(json: any): GetContractDocumentsResponseDto {
    return GetContractDocumentsResponseDtoToJSONTyped(json, false);
}

export function GetContractDocumentsResponseDtoToJSONTyped(value?: GetContractDocumentsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['documents'] as Array<any>).map(GenericDocumentDtoToJSON)),
    };
}

